import { safeLocalStorage } from '@/lib/safe-storage'

/* Remembers that the user left the canvas to pay, so the upgrade
 * orchestration (license + design attach) can resume when they return —
 * even across a full redirect through Stripe. The Stripe webhook performs
 * the same idempotent orchestration server-side as a fallback for users
 * who never come back to the tab. */

const KEY = 'canvasPendingUpgrade'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export function setPendingUpgrade({ projectId, uniqueUrl, workspace, intent }) {
    try {
        safeLocalStorage.setItem(
            KEY,
            JSON.stringify({ projectId, uniqueUrl, workspace, intent, ts: Date.now() })
        )
    } catch {
        /* storage full/blocked — webhook fallback still covers the upgrade */
    }
}

export function getPendingUpgrade() {
    try {
        const raw = safeLocalStorage.getItem(KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed?.ts || Date.now() - parsed.ts > MAX_AGE_MS) {
            clearPendingUpgrade()
            return null
        }
        return parsed
    } catch {
        return null
    }
}

export function clearPendingUpgrade() {
    try {
        safeLocalStorage.removeItem(KEY)
    } catch {
        /* ignore */
    }
}
